export default __webpack_public_path__ + "static/testimonial_1-913b97fe7da95e712b593b8f527a1d80.png";